export default __webpack_public_path__ + "static/media/faq.24ef5a38.png";